import React,{useState, useRef,useEffect} from "react";
import { InpDataList } from "@gull";
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import SweetAlert from "sweetalert2-react";

const useSearchClients = () => {
    const [loadingSearchClient,setLoadingSearchClient]=useState(false)
    const [generalErrorSearchClient,setGeneralErrorSearchClient]=useState(false)
    const [listSearchClient,setListSearchClient]=useState([])
    const [datas,setDatas]=useState([])
    const searchInputClient = useRef('')

    const loadClients = async (toSearch) => {
        setLoadingSearchClient(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/client/name/"+toSearch
        ).then((response) => {
            setListSearchClient(response.data.datas)
            let initial = []
            response.data.datas.forEach((value)=>
                initial.push({
                    id: value.id,
                    name: value.name+' '+value.firstname+' - '+value.email+' - '+value.tel
                })
            )
            setListSearchClient(initial)
            let ajour = initial.filter((value)=>value.name.toLowerCase().includes(searchInputClient.current.value.toLowerCase()))
            setDatas(ajour)
            setLoadingSearchClient(false)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchClient(false)
            setGeneralErrorSearchClient(true)
        })
    }

    return [loadingSearchClient,loadClients,generalErrorSearchClient,setGeneralErrorSearchClient,listSearchClient,datas,setDatas,searchInputClient]
}

const InputSearchClient = (props) =>{
    const t =useTranslate()
    const [loadingSearchClient,loadClients,generalErrorSearchClient,setGeneralErrorSearchClient,listSearchClient,datas,setDatas,searchInputClient]=useSearchClients()

    const [clientName,setClientName] = useState('')
    const [lastSelectedName,setLastSelectedName] = useState('')
    const [noClientToEdit,setNoClientToEdit] = useState(false)
    const [lastSearch,setLastSearch]=useState(false)

    const dataListDropClient = useRef('')

    const toggleAlertSearchClient = () => {
        setGeneralErrorSearchClient(false)
    }

    const toggleNoClientToEdit = () => {
        setNoClientToEdit(false)
    }

    //Utilisé uniquement sur la création de facture/devis dans le module facturation pour renseigner le nom du nouveau dans cette input
    useEffect(function () {
        if(props.from=='facturation' && props.clientDetail && Object.keys(props.clientDetail).length==0){
            if (props.clientName) setClientName(props.clientName)
            else setClientName('')
        }else if(props.from=='facturation' && props.clientDetail && Object.keys(props.clientDetail).length!=0){
            let fullName = props.clientDetail.name+' '+props.clientDetail.firstname+' - '+props.clientDetail.email+' - '+props.clientDetail.tel
            setClientName(fullName)
            setLastSelectedName(fullName)
        }else if(props.changeDossierClient){
            //Exécuté depuis le détail d'un document pour afficher le nom de client
            setClientName(props.changeDossierClient.name+' '+props.changeDossierClient.firstname+' - '+props.changeDossierClient.email+' - '+props.changeDossierClient.tel)
        }
    }, [props.clientDetail])

    useEffect(function () {
        if(props.defaultClientName) setClientName(props.defaultClientName)
    }, [props.defaultClientName])

    const handleSearch = (e,declenchement) => {
        setClientName(e.target.value)
        if (props.setClientName) props.setClientName(e.target.value)
        if(e.target.value.length>=declenchement){
            dataListDropClient.current.classList.remove("d-none");

            if(!lastSearch || e.target.value.substring(0, declenchement) != lastSearch.substring(0, declenchement)){
                loadClients(e.target.value.substring(0, declenchement))
                setLastSearch(e.target.value.substring(0, declenchement))
            }
        }else{
            dataListDropClient.current.classList.add("d-none");
            setLastSearch(false)
        }
        if(e.target.value.length!=declenchement){
            let ajour = listSearchClient.filter((value)=>value.name.toLowerCase().includes(e.target.value.toLowerCase()))
            setDatas(ajour)
        }
    }

    const handleCLick = (id,valeur) => {
        props.setClient(id)
        setClientName(valeur)
        setLastSelectedName(valeur)
        if (props.setClientName) props.setClientName(valeur)
        if(props.setClientInfo) props.setClientInfo(valeur)
        dataListDropClient.current.classList.add("d-none");
    }

    const handleBlur = () => {
        if(clientName==''){
            if(props.keepSelectionOnClear && lastSelectedName!=''){
                setClientName(lastSelectedName)
            }else{
                props.setClient(false)
            }
        }
        dataListDropClient.current.classList.add("d-none");
    }

    const handleFocus = () => {
        searchInputClient.current.select();
    }

    return(
        <>
            <div className="position-relative">
                <InpDataList
                    placeholder={t('customerPlacehlder')}
                    value={clientName}
                    onClick={handleCLick}
                    onChange={handleSearch}
                    datas={datas}
                    declenchement={3}
                    listRef={dataListDropClient}
                    inputRef={searchInputClient}
                    onBlur={handleBlur}
                    disabled={props.disabled || props.changeDossierClient}
                    inputName="searchClient"
                    onFocus={handleFocus}
                />
                {(loadingSearchClient) ?
                    <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm topBarLeftPosition2"></div></span>
                :
                    false
                }
            </div>
            {(generalErrorSearchClient) &&
                <SweetAlert show="true" title={t('unknowError')} type="error" onConfirm={() => toggleAlertSearchClient()}/>
            }
            {(noClientToEdit) &&
                    <SweetAlert show="true" title={t('noClientToEdit')} type="error" onConfirm={() => toggleNoClientToEdit()}/>
            }
        </>
    )
}

export default InputSearchClient;